{
  "slug": "is-iq-genetic",
  "title": "智商是遗传的吗?",
  "description": "了解基因和环境如何促成认知差异,以及遗传性的含义。",
  "summary": "认知能力受到许多遗传变异和许多环境因素的影响,这两者在整个发育过程中相互作用。",
  "sections": [
    {
      "heading": "许多影响,而不是一个智商基因",
      "paragraphs": [
        "遗传差异会导致认知测试分数的变化，但没有一个单一的基因决定一个人的智商。其影响分布在许多变量之间，每个变量的影响通常都很小。",
        "生物学在环境中发展,营养、健康、教育、安全、压力、家庭资源和机会都会影响认知技能的发展和表现。"
      ]
    },
    {
      "heading": "什么是遗传性",
      "paragraphs": [
        "遗传性是一种人口统计学，描述在特定条件下观察到的变异与遗传差异有多大关系，而不是说一个人的智力中有多少百分比是遗传的。",
        "一个特征可以是遗传的,但仍然会对环境变化做出反应,估计值因年龄、人口和社会条件而异。"
      ]
    },
    {
      "heading": "避免决定性结论",
      "paragraphs": [
        "DNA测试结果无法完全或确定地预测一个人的未来认知能力，群体平均值也无法确定一个人的潜力。",
        "支持性的环境、有效的教育、医疗保健和机会仍然是有意义的。 负责任的解释从不使用智商来排列人类价值。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "智商有多少是遗传的?",
      "answer": "对于一个人来说,没有单一的百分比,人口估计因年龄、环境、人口和研究方法而异。"
    },
    {
      "question": "环境能影响智商吗?",
      "answer": "是的,教育、健康、营养、压力、语言和机会都会影响孩子的发展和考试表现。"
    }
  ],
  "related": ["can-iq-change-over-time", "what-is-iq", "iq-vs-intelligence"]
}
